export default "__VITE_ASSET__4c7b3d14__"